import AuditIcon from "../components/Icons/AuditIcon";
import ClassificationIcon from "../components/Icons/ClassificationIcon";
import ExtractionIcon from "../components/Icons/ExtractionIcon";
import IncomeIcon from "../components/Icons/IncomeIcon";
import VersioningIcon from "../components/Icons/VersioningIcon";
import AuditService from "../pages/Services/audit.service";
import ClassificationService from "../pages/Services/classification.service";
import ExtractionService from "../pages/Services/extraction.service";
import IncomeService from "../pages/Services/income.service";
import VerifaiExtractionService from "../pages/Services/verifai.extraction.service";
import VerifaiVersioningService from "../pages/Services/verifai.versioning.service";
import VersioningService from "../pages/Services/versioning.service";

const Services = {
  classification: {
    id: "classification",
    trapezeId: "ClassificationQueue",
    label: "Classification",
    itemType: "batch",
    tableName: `Documents`,
    icon: <ClassificationIcon />,
    component: <ClassificationService />,
  },
  versioning: {
    id: "versioning",
    trapezeId: "VersionQueue",
    label: "Versioning",
    itemType: "document type",
    tableName: `Document Types`,
    icon: <VersioningIcon />,
    component: <VersioningService />,
  },
  verifaiVersioning: {
    id: "verifaiVersioning",
    label: "Versioning",
    itemType: "document type",
    tableName: `Document Types`,
    icon: <VersioningIcon />,
    component: <VerifaiVersioningService />,
  },
  extraction: {
    id: "extraction",
    trapezeId: ["Final", "Validation"],
    label: "Extraction",
    itemType: "document",
    tableName: `Documents`,
    icon: <ExtractionIcon />,
    component: <ExtractionService />,
  },
  verifaiExtraction: {
    id: "verifaiExtraction",
    label: "Extraction",
    itemType: "document",
    tableName: "Documents",
    icon: <ExtractionIcon />,
    component: <VerifaiExtractionService />,
  },
  income: {
    id: "income",
    label: "Income",
    itemType: "report",
    tableName: `Reports`,
    icon: <IncomeIcon />,
    component: <IncomeService />,
  },
  audit: {
    id: "audit",
    label: "Data Verification",
    itemType: "report",
    tableName: `Reports`,
    icon: <AuditIcon />,
    component: <AuditService />,
  },
};

export const getIdFromTrapezeId = (trapezeId) => {
  switch (trapezeId) {
    case Services.classification.trapezeId:
      return Services.classification.id;
    case Services.versioning.trapezeId:
      return Services.versioning.id;
    case Services.extraction.trapezeId[0]:
    case Services.extraction.trapezeId[1]:
      return Services.extraction.id;
    case Services.income.trapezeId:
      return Services.income.id;
    case Services.audit.id:
      return Services.audit.id;
    default:
      return trapezeId;
  }
};

export default Services;
